const actionTypeIdentifier = "AB7C77AF-6198-4DC5-9D71-B4BE2B641Z8G";

export const setCostCenterHistoryLogsLoading = `SET-COST-CENTER-HISTORY-LOGS-LOADING-${actionTypeIdentifier}`;
export const getCostCenterHistoryLogs = `GET-COST-CENTER-HISTORY-LOGS-${actionTypeIdentifier}`;
export const setCostCenterHistoryPageSize = `SET-COST-CENTER-HISTORY-PAGE-SIZE-${actionTypeIdentifier}`;
export const resetCostCenterHistory = `RESET-COST-CENTER-HISTORY-${actionTypeIdentifier}`;
export const setCostCenterHistoryColSearchStr = `SET-COST-CENTER-HISTORY-COL-SEARCH-${actionTypeIdentifier}`;
export const setDefaultCostCenterHistory = `SET-DEFAULT-COST-CENTER-HISTORY-${actionTypeIdentifier}`;